import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { paymentsAPI } from '../lib/api';
import { Lock, ChevronRight, Crosshair, BarChart3, Video, Flame, Loader2 } from 'lucide-react';

export default function SubscriptionGate({ children, feature = "content" }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  if (user?.subscription_active) return children;

  const features = {
    training: { title: "UNLOCK YOUR TRAINING", desc: "Get your personalized weekly training plan with daily drills and video instruction." },
    feedback: { title: "UNLOCK COACH FEEDBACK", desc: "Upload your reps and get direct feedback from pro coaches within 24-48 hours." },
    progress: { title: "UNLOCK YOUR PLAN", desc: "Track your weekly progress, build streaks, and see your full training schedule." },
    content: { title: "UNLOCK PREMIUM", desc: "Subscribe to access all training content and features." },
  };

  const config = features[feature] || features.content;

  const handleSubscribe = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const userEmail = user?.email || '';
      const trialLink = `https://buy.stripe.com/14AaEWbmp06zgyU2873AY02${userEmail ? `?prefilled_email=${encodeURIComponent(userEmail)}` : ''}`;
      window.location.href = trialLink;
    } catch (err) {
      console.error('Checkout failed:', err);
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[80vh] px-4">
      <div className="bg-white border border-[#E2E8F0] rounded-2xl max-w-sm w-full p-8 text-center shadow-lg">
        <img src="/logo-coach-player.png" alt="Elev802 Connected" className="h-32 w-auto mx-auto mb-6 rounded-xl" />

        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0A2242]/10 border border-[#0A2242]/20 mb-4">
          <Lock size={12} className="text-[#0A2242]" />
          <span className="text-[10px] text-[#0A2242] font-bold uppercase tracking-widest">Founders Only</span>
        </div>

        <h2 className="font-['Barlow_Condensed'] text-2xl font-bold mb-3 tracking-tight text-[#0A2242]">{config.title}</h2>
        <p className="text-sm text-[#64748B] mb-6 leading-relaxed">{config.desc}</p>

        <button
          onClick={handleSubscribe}
          disabled={loading}
          className="w-full bg-[#0A2242] text-white font-black uppercase tracking-wide rounded-lg px-8 py-4 transition-all hover:bg-[#0E2D5A] text-sm flex items-center justify-center gap-2 disabled:opacity-60"
          data-testid="subscribe-cta"
        >
          {loading ? (
            <><Loader2 size={16} className="animate-spin" /> Processing...</>
          ) : (
            <>Subscribe — $14.99/mo <ChevronRight size={18} /></>
          )}
        </button>
        <p className="text-xs text-[#94A3B8] mt-3">Founders Level. Cancel anytime.</p>

        <div className="mt-8 pt-6 border-t border-[#E2E8F0]">
          <div className="space-y-3 text-left text-sm">
            {[
              { icon: Crosshair, text: "Personalized weekly drills" },
              { icon: Video, text: "Pro video instruction" },
              { icon: BarChart3, text: "Progress tracking & streaks" },
              { icon: Flame, text: "Direct coach feedback" },
            ].map(({ icon: Icon, text }, i) => (
              <div key={i} className="flex items-center gap-3 text-[#64748B]">
                <Icon size={16} className="text-[#2563EB] flex-shrink-0" />
                <span>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
